import storage from 'redux-persist/lib/storage';
import { PersistConfig } from 'redux-persist';

import { PersonalAccountState } from '../store/types';

export const personalAccountPersistConfig: PersistConfig<PersonalAccountState> =
  {
    key: 'personalAccount',
    storage,
  };
